import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loginUser: (data) => apiCall("login", data),
  forgotPassword: (data) => apiCall("system/user/forgot_password", data),
  resetPassword: (data) => apiCall("password/reset", data),
  activateAccount: (data) => apiCall("user/account/activate", data),
  fetchUserList: (data) => apiCall("user/list", data),
  fetchSingleUser: (data) => apiCall("user/get", data),
  createUser: (data) => apiCall("user/create", data),
  updateUser: (data) => apiCall("user/update", data),
  updateProfile: (data) => apiCall("user/profile/update", data),
  updatePassword: (data) => apiCall("password/update", data),
  updatePasswordByAdmin: (data) => apiCall("password/update/admin", data),
  disableUser: (data) => apiCall("user/disable", data),
  enableUser: (data) => apiCall("user/enable", data),
  inviteUser: (data) => apiCall("user/invite", data),
  acceptInvitation: (data) => apiCall("user/invitation/accept", data),
  // Both run unauthenticated — the emailed token is the credential.
  invitationDetails: (data) => apiCall("user/invitation/details", data),
  completeInvitation: (data) => apiCall("user/invitation/complete", data),
  getUserPermissionCodes: (data) =>
    apiCall("system/user/permission-codes", data),
  searchUsers: (data) => apiCall("user/search", data),
  countUsers: (data) => apiCall("user/count", data),
};
